var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('title.tradelinks')))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('message.selecionar_tradelinks')))]),_c('v-card-text',[_c('tenant-list',{on:{"TenantList_selecionarTenant":_vm.selecionarTenant}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }